/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentPartConfigurationResponse
 */
export interface EquipmentPartConfigurationResponse {
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartConfigurationResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartConfigurationResponse
     */
    configurationId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartConfigurationResponse
     */
    partId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartConfigurationResponse
     */
    position?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartConfigurationResponse
     */
    locationId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartConfigurationResponse
     */
    secondaryLocationId?: number;
    /**
     * 
     * @type {Date}
     * @memberof EquipmentPartConfigurationResponse
     */
    effectiveDate?: Date;
}

/**
 * Check if a given object implements the EquipmentPartConfigurationResponse interface.
 */
export function instanceOfEquipmentPartConfigurationResponse(value: object): value is EquipmentPartConfigurationResponse {
    return true;
}

export function EquipmentPartConfigurationResponseFromJSON(json: any): EquipmentPartConfigurationResponse {
    return EquipmentPartConfigurationResponseFromJSONTyped(json, false);
}

export function EquipmentPartConfigurationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentPartConfigurationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'configurationId': json['configurationId'] == null ? undefined : json['configurationId'],
        'partId': json['partId'] == null ? undefined : json['partId'],
        'position': json['position'] == null ? undefined : json['position'],
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'secondaryLocationId': json['secondaryLocationId'] == null ? undefined : json['secondaryLocationId'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
    };
}

export function EquipmentPartConfigurationResponseToJSON(json: any): EquipmentPartConfigurationResponse {
    return EquipmentPartConfigurationResponseToJSONTyped(json, false);
}

export function EquipmentPartConfigurationResponseToJSONTyped(value?: EquipmentPartConfigurationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'configurationId': value['configurationId'],
        'partId': value['partId'],
        'position': value['position'],
        'locationId': value['locationId'],
        'secondaryLocationId': value['secondaryLocationId'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate']).toISOString().substring(0,10)),
    };
}

